import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
export var useEditableRows = function useEditableRows(_ref) {
  var uniqueKey = _ref.uniqueKey,
      rows = _ref.rows,
      dsOnEditChange = _ref.dsOnEditChange,
      delegatedEditableRow = _ref.delegatedEditableRow;

  var _React$useState = React.useState(delegatedEditableRow),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editableRow = _React$useState2[0],
      setEditableRow = _React$useState2[1];

  React.useEffect(function () {
    setEditableRow(delegatedEditableRow);
  }, [delegatedEditableRow]);

  var handleToggleRowEdit = function handleToggleRowEdit(row) {
    if (!editableRow || row[uniqueKey] !== editableRow[uniqueKey]) {
      setEditableRow(row);
    } else if (row[uniqueKey] === editableRow[uniqueKey]) {
      var rowIndex = rows.findIndex(function (r) {
        return r[uniqueKey] === row[uniqueKey];
      });
      dsOnEditChange === null || dsOnEditChange === void 0 ? void 0 : dsOnEditChange({
        row: editableRow,
        rowIndex: rowIndex
      });
      setEditableRow(undefined);
    }
  };

  var handleInputChange = React.useCallback(function (_ref2) {
    var value = _ref2.value,
        column = _ref2.column;

    var newRow = _objectSpread({}, editableRow);

    newRow[column.field] = value;
    setEditableRow(newRow);
  }, [editableRow]);
  return {
    editableRow: editableRow,
    handleToggleRowEdit: handleToggleRowEdit,
    handleInputChange: handleInputChange
  };
};
export var useCustomColumns = function useCustomColumns(_ref3) {
  var inputColumns = _ref3.inputColumns,
      dsOnColumnsChange = _ref3.dsOnColumnsChange;

  var reshapeInputColumns = function reshapeInputColumns(inputCols) {
    return inputCols.map(function (c) {
      if ('hidden' in c) {
        return c;
      }

      return _objectSpread(_objectSpread({}, c), {}, {
        hidden: false
      });
    });
  };

  var _React$useState3 = React.useState(function () {
    return reshapeInputColumns(inputColumns);
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      columns = _React$useState4[0],
      setColumns = _React$useState4[1];

  var handleColumnsChange = function handleColumnsChange(columns) {
    setColumns(columns);
    dsOnColumnsChange === null || dsOnColumnsChange === void 0 ? void 0 : dsOnColumnsChange(columns);
  };

  React.useEffect(function () {
    setColumns(reshapeInputColumns(inputColumns));
  }, [inputColumns]);
  return {
    columns: columns,
    handleColumnsChange: handleColumnsChange
  };
};
export var usePagination = function usePagination(_ref4) {
  var inputRowsPerPage = _ref4.inputRowsPerPage,
      dsOnPage = _ref4.dsOnPage;

  var _React$useState5 = React.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      page = _React$useState6[0],
      setPage = _React$useState6[1];

  var _React$useState7 = React.useState(inputRowsPerPage || 5),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      rowsPerPage = _React$useState8[0],
      setRowsPerPage = _React$useState8[1];

  var _React$useMemo = React.useMemo(function () {
    return {
      pageStart: page * rowsPerPage,
      pageEnd: page * rowsPerPage + rowsPerPage
    };
  }, [page, rowsPerPage]),
      pageStart = _React$useMemo.pageStart,
      pageEnd = _React$useMemo.pageEnd;

  var handleChangePage = function handleChangePage(newPage) {
    setPage(newPage);
    dsOnPage === null || dsOnPage === void 0 ? void 0 : dsOnPage({
      page: newPage,
      rowsPerPage: rowsPerPage
    });
  };

  var updateRowsPerPage = function updateRowsPerPage(rowsPerPage) {
    setRowsPerPage(rowsPerPage);
    setPage(0);
    dsOnPage === null || dsOnPage === void 0 ? void 0 : dsOnPage({
      page: 0,
      rowsPerPage: rowsPerPage
    });
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    updateRowsPerPage(+event.target.value);
  };

  return {
    page: page,
    rowsPerPage: rowsPerPage,
    pageStart: pageStart,
    pageEnd: pageEnd,
    handleChangePage: handleChangePage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    handleSetRowsPerPage: updateRowsPerPage
  };
};
export var useSearch = function useSearch(_ref5) {
  var page = _ref5.page,
      handleChangePage = _ref5.handleChangePage,
      dsOnSearchChange = _ref5.dsOnSearchChange;

  var _React$useState9 = React.useState(''),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      search = _React$useState10[0],
      setSearch = _React$useState10[1];

  var handleSearch = function handleSearch(event) {
    setSearch(event.target.value);
    dsOnSearchChange === null || dsOnSearchChange === void 0 ? void 0 : dsOnSearchChange(event.target.value);
    if (page > 0) handleChangePage(0);
  };

  return {
    search: search,
    handleSearch: handleSearch
  };
};
export var useSort = function useSort(_ref6) {
  var _initialSort$, _initialSort$$order, _initialSort$2;

  var dsOnSort = _ref6.dsOnSort,
      initialSort = _ref6.initialSort,
      sortStrategy = _ref6.sortStrategy;

  var _React$useState11 = React.useState((initialSort === null || initialSort === void 0 ? void 0 : (_initialSort$ = initialSort[0]) === null || _initialSort$ === void 0 ? void 0 : (_initialSort$$order = _initialSort$.order) === null || _initialSort$$order === void 0 ? void 0 : _initialSort$$order.toLowerCase()) || 'asc'),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      order = _React$useState12[0],
      setOrder = _React$useState12[1];

  var _React$useState13 = React.useState((initialSort === null || initialSort === void 0 ? void 0 : (_initialSort$2 = initialSort[0]) === null || _initialSort$2 === void 0 ? void 0 : _initialSort$2.field) || undefined),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      orderBy = _React$useState14[0],
      setOrderBy = _React$useState14[1];

  var handleSortClick = function handleSortClick(property) {
    var isAsc = orderBy === property && order === 'asc';

    if (sortStrategy === 'client') {
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    } else if (sortStrategy === 'server') {
      dsOnSort([{
        field: property,
        order: (isAsc ? 'desc' : 'asc').toUpperCase()
      }]);
    }
  };

  React.useEffect(function () {
    if (sortStrategy === 'client') {
      dsOnSort === null || dsOnSort === void 0 ? void 0 : dsOnSort([{
        field: orderBy,
        order: order.toUpperCase()
      }]);
    }
  }, [dsOnSort, order, orderBy]);
  React.useEffect(function () {
    var _initialSort$3, _initialSort$3$order, _initialSort$4;

    setOrder(initialSort === null || initialSort === void 0 ? void 0 : (_initialSort$3 = initialSort[0]) === null || _initialSort$3 === void 0 ? void 0 : (_initialSort$3$order = _initialSort$3.order) === null || _initialSort$3$order === void 0 ? void 0 : _initialSort$3$order.toLowerCase());
    setOrderBy(initialSort === null || initialSort === void 0 ? void 0 : (_initialSort$4 = initialSort[0]) === null || _initialSort$4 === void 0 ? void 0 : _initialSort$4.field);
  }, [initialSort]);
  return {
    order: order,
    orderBy: orderBy,
    handleSortClick: handleSortClick
  };
};
export var useGroupedData = function useGroupedData(_ref7) {
  var groupByKey = _ref7.groupByKey,
      searchedAndSortedRows = _ref7.searchedAndSortedRows,
      nestedDataKey = _ref7.nestedDataKey;

  var _React$useState15 = React.useState({}),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      collapsedGroups = _React$useState16[0],
      setCollapsedGroups = _React$useState16[1];

  var onToggleHeaderRow = function onToggleHeaderRow(key) {
    setCollapsedGroups(_objectSpread(_objectSpread({}, collapsedGroups), {}, _defineProperty({}, key, !collapsedGroups[key])));
  };

  var groupedRows = React.useMemo(function () {
    if (!groupByKey) {
      return {
        collection: searchedAndSortedRows,
        map: {
          '': searchedAndSortedRows
        }
      };
    } // a map of grouped rows, sorted into buckets
    // by groupByKey


    var map = searchedAndSortedRows.reduce(function (acc, row) {
      // omit nested rows
      if (row.hasOwnProperty(String(nestedDataKey))) return acc;
      var key = String(row[groupByKey]);
      if (Array.isArray(key)) return acc;

      if (Array.isArray(acc[key])) {
        // @ts-ignore
        acc[key].push(row);
      } else {
        // @ts-ignore
        acc[key] = [row];
      }

      return acc;
    }, {}); // a flat ordered collection of each bucket, joined "end to end"

    var collection = [];
    Object.entries(map).forEach(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          key = _ref9[0],
          children = _ref9[1];

      // cut collapsed collections out
      if (!collapsedGroups[key]) {
        collection = collection.concat(children);
      }
    });
    return {
      map: map,
      collection: collection
    };
  }, [searchedAndSortedRows, groupByKey, collapsedGroups]);
  return {
    collapsedGroups: collapsedGroups,
    groupedRows: groupedRows,
    onToggleHeaderRow: onToggleHeaderRow
  };
};

var flattenChildren = function flattenChildren(rows, nestedRowsMap, uniqueKey) {
  return rows.reduce(function (acc, row) {
    // @ts-ignore TODO fix row indexes
    if (nestedRowsMap[row[uniqueKey]]) {
      return acc.concat(flattenChildren( // @ts-ignore TODO: fix row indexes
      nestedRowsMap[row[uniqueKey]], nestedRowsMap, uniqueKey), row);
    }

    return [].concat(_toConsumableArray(acc), [row]);
  }, []);
};

export var useMultiSelect = function useMultiSelect(_ref10) {
  var uniqueKey = _ref10.uniqueKey,
      selectedRows = _ref10.selectedRows,
      rowsInView = _ref10.rowsInView,
      nestedRowsMap = _ref10.nestedRowsMap,
      dsOnSelectionChange = _ref10.dsOnSelectionChange;

  var _React$useState17 = React.useState({}),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      selectedMap = _React$useState18[0],
      setSelectedMap = _React$useState18[1];

  React.useEffect(function () {
    if (selectedRows) {
      setSelectedMap(selectedRows);
    }
  }, [selectedRows]);

  var handleSetSelected = function handleSetSelected(sMap) {
    setSelectedMap(sMap); // TODO: pass back the values? or the hash map?

    dsOnSelectionChange && dsOnSelectionChange(Object.values(sMap));
  };

  var handleSelectAllClick = function handleSelectAllClick(event) {
    if (event.target.checked) {
      var newlySelected = flattenChildren(rowsInView, nestedRowsMap, uniqueKey).reduce(function (acc, row) {
        // @ts-ignore TODO fix row indexes
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, row[uniqueKey], row));
      }, {});
      handleSetSelected(_objectSpread(_objectSpread({}, selectedMap), newlySelected));
      return;
    }

    handleSetSelected({});
  };

  var handleCheckboxClick = function handleCheckboxClick(row, key) {
    var newSelected = _objectSpread({}, selectedMap); // @ts-ignore TODO fix row indexes


    if (newSelected[key]) {
      // @ts-ignore TODO fix row indexes
      delete newSelected[key];
    } else {
      // @ts-ignore TODO fix row indexes
      newSelected[key] = row;
    }

    handleSetSelected(newSelected);
  };

  var handleClearSelections = function handleClearSelections() {
    handleSetSelected({});
  }; // TODO: this merely requires the presence of a truthy value
  // what should this be? the "number of selected rows" counts the length
  // of this collection, it does not consider the value of a k,v pair


  var isSelected = function isSelected(key) {
    return !!selectedMap[key];
  };

  return {
    selectedMap: selectedMap,
    handleSelectAllClick: handleSelectAllClick,
    handleCheckboxClick: handleCheckboxClick,
    handleClearSelections: handleClearSelections,
    isSelected: isSelected
  };
};

try {
  useEditableRows.__docgenInfo = {
    description: '',
    displayName: 'useEditableRows',
    methods: [],
    props: {
      rows: {
        defaultValue: null,
        description: '',
        name: 'rows',
        required: true,
        type: {
          name: 'any'
        }
      },
      uniqueKey: {
        defaultValue: null,
        description: '',
        name: 'uniqueKey',
        required: true,
        type: {
          name: 'any'
        }
      },
      dsOnEditChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnEditChange',
        required: true,
        type: {
          name: 'any'
        }
      },
      delegatedEditableRow: {
        defaultValue: null,
        description: '',
        name: 'delegatedEditableRow',
        required: true,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}

try {
  useCustomColumns.__docgenInfo = {
    description: '',
    displayName: 'useCustomColumns',
    methods: [],
    props: {
      inputColumns: {
        defaultValue: null,
        description: '',
        name: 'inputColumns',
        required: true,
        type: {
          name: 'any'
        }
      },
      dsOnColumnsChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnColumnsChange',
        required: true,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}

try {
  usePagination.__docgenInfo = {
    description: '',
    displayName: 'usePagination',
    methods: [],
    props: {
      inputRowsPerPage: {
        defaultValue: null,
        description: '',
        name: 'inputRowsPerPage',
        required: true,
        type: {
          name: 'any'
        }
      },
      dsOnPage: {
        defaultValue: null,
        description: '',
        name: 'dsOnPage',
        required: true,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}

try {
  useSearch.__docgenInfo = {
    description: '',
    displayName: 'useSearch',
    methods: [],
    props: {
      page: {
        defaultValue: null,
        description: '',
        name: 'page',
        required: true,
        type: {
          name: 'number'
        }
      },
      handleChangePage: {
        defaultValue: null,
        description: '',
        name: 'handleChangePage',
        required: true,
        type: {
          name: '(newPage: number) => void'
        }
      },
      dsOnSearchChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnSearchChange',
        required: true,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}

try {
  useSort.__docgenInfo = {
    description: '',
    displayName: 'useSort',
    methods: [],
    props: {
      dsOnSort: {
        defaultValue: null,
        description: '',
        name: 'dsOnSort',
        required: true,
        type: {
          name: 'any'
        }
      },
      initialSort: {
        defaultValue: null,
        description: '',
        name: 'initialSort',
        required: true,
        type: {
          name: 'any'
        }
      },
      sortStrategy: {
        defaultValue: null,
        description: '',
        name: 'sortStrategy',
        required: true,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}

try {
  useGroupedData.__docgenInfo = {
    description: '',
    displayName: 'useGroupedData',
    methods: [],
    props: {
      groupByKey: {
        defaultValue: null,
        description: '',
        name: 'groupByKey',
        required: true,
        type: {
          name: 'any'
        }
      },
      searchedAndSortedRows: {
        defaultValue: null,
        description: '',
        name: 'searchedAndSortedRows',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      nestedDataKey: {
        defaultValue: null,
        description: '',
        name: 'nestedDataKey',
        required: false,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}

try {
  useMultiSelect.__docgenInfo = {
    description: '',
    displayName: 'useMultiSelect',
    methods: [],
    props: {
      uniqueKey: {
        defaultValue: null,
        description: '',
        name: 'uniqueKey',
        required: true,
        type: {
          name: 'any'
        }
      },
      selectedRows: {
        defaultValue: null,
        description: '',
        name: 'selectedRows',
        required: true,
        type: {
          name: 'any'
        }
      },
      rowsInView: {
        defaultValue: null,
        description: '',
        name: 'rowsInView',
        required: true,
        type: {
          name: 'any[]'
        }
      },
      nestedRowsMap: {
        defaultValue: null,
        description: '',
        name: 'nestedRowsMap',
        required: true,
        type: {
          name: '{ [key: string]: any[]; }'
        }
      },
      dsOnSelectionChange: {
        defaultValue: null,
        description: '',
        name: 'dsOnSelectionChange',
        required: true,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=hooks.js.map